export const PREPAGE = 10;
export const PERPAGEFORNODISTANCE = 12;

export const EMAIL_PATTERN =
  /* eslint-disable-next-line */
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const LOCATIONCATEGORIES = [
  "Castrol Service",
  "Castrol Service Certified",
];

export const CountriesWithCustomizedWTB = ["ROU", "ESP"];
export const CountriesWithCustomizedWTBImage = ["GBR"];

export const GLOBALFONTFAMILY = [
  {
    countries: ["CES", "HRV", "HUN", "POL", "RON", "SLK", "SLV", "SRP", "ROU"],
    fontFamily: "Castrol Sans Central European,Arial,Helvetica,sans-serif",
  },
  {
    countries: ["BUL", "KAZ", "RUS", "UKR"],
    fontFamily: "Castrol Sans Cyrillic,Arial,Helvetica,sans-serif",
  },
  {
    countries: ["AZE"],
    fontFamily: "HelveticaNeue-Bold",
  },
  {
    countries: ["VIE"],
    fontFamily: "Castrol Sans VI Regular",
  },
  {
    countries: [
      "DAN",
      "DEU",
      "ENG",
      "SPA",
      "FIN",
      "FRA",
      "ITA",
      "NLD",
      "NOR",
      "POR",
      "SWE",
    ],
    fontFamily: "Castrol Sans Western European,Arial,Helvetica,sans-serif",
  },
  {
    countries: ["JPN"],
    fontFamily: "Meiryo,MS PGothic,Arial,Helvetica,sans-serif",
  },
];

export const NODISTANCECOUNTRIES = ["GBR"];

export const MAP_PROD_TO_LOCA = {
  Cars: "Car Workshop",
  Motorcycles: "Bike Workshop",
  "Commercial Vehicles": "Commercial Vehicles Workshop",
};

export const RETAIL_OUTLET = "Retail Outlet";

export const ONLYWTBCOUNTRIES = [
  'EST',
  'LVA',
  'LTU',
  'ALB',
  'BIH',
  'MLT',
  'BGR',
  'HRV',
  'ISL',
  'SRB',
  'SVN',
  'VEN',
  'BHR',
  'PAN',
  'LBH',
  'ETH',
  'LBY',
  'SLV',
  'SLE',
  'BGD',
  'MUS',
  'YEM',
  'IRQ',
  'GHA',
  'KOR',
  'SAU',
  'NAM',
  'URY',
  'MEX',
  'LBN',
  'IND',
  'DZA',
  'AGO',
  'ARG',
  'BOL',
  'BRA',
  'CHN',
  'CRI',
  'CUW',
  'EGY',
  'GMB',
  'GTM',
  'HND',
  'ISR',
  'JPN',
  'KWT',
  'MDV',
  'MMR',
  'MOZ',
  'NGA',
  'OMN',
  'PAK',
  'PRY',
  'PER',
  'PHL',
  'PRI',
  'QAT',
  'SGP',
  'LKA',
  'TWN',
  'TTO',
  'CHL',
  'PNG',
  'DJI',
  'COL'
];



export const FASTSCAN = 'FastScan';
export const APPNAME = 'ApplicationName';

export const PRESERVED = 'Preserved';
export const SEARCHSTATE = 'SearchState';

export const UNDETECT_LOCATION_PERMISSIONS = 'undetect_location_permissions';
